import React, { Component, Fragment } from 'react';
import AdjacentContentBox from '../../../../shared/AdjacentContentBox';
import StatsNumber from './StatsNumber';
import tooltip from '../../../../shared/tooltip/tooltip.json';

class StatsNumbers extends Component {
    render() {
        return (
            <Fragment>
                <div className="row-adjacent-content">
                    <AdjacentContentBox
                        title="Total Number of Players"
                        content={
                            <StatsNumber
                                fromNowOn={this.props.sandbox}
                                current={
                                    this.props.data.totalNumberOfPlayers.number
                                }
                                lastWeek={
                                    this.props.data.totalNumberOfPlayers
                                        .numberLastWeek
                                }
                            />
                        }
                        tooltipMessage={tooltip.dashboard.totalNumberOfPlayers}
                    />

                    <AdjacentContentBox
                        title="Number of Active Players (Last 24h)"
                        content={
                            <StatsNumber
                                fromNowOn={this.props.sandbox}
                                current={
                                    this.props.data
                                        .numberOfActivePlayersForTheLastDay
                                        .number
                                }
                                lastWeek={
                                    this.props.data
                                        .numberOfActivePlayersForTheLastDay
                                        .numberLastWeek
                                }
                            />
                        }
                        tooltipMessage={tooltip.dashboard.numberOfActivePlayers}
                    />
                </div>
                <div className="row-adjacent-content">
                    <AdjacentContentBox
                        title="Number of Bets (Last 24h)"
                        content={
                            <StatsNumber
                                fromNowOn={this.props.sandbox}
                                current={
                                    this.props.data.numberOfBetsForTheLastDay
                                        .number
                                }
                                lastWeek={
                                    this.props.data.numberOfBetsForTheLastDay
                                        .numberLastWeek
                                }
                            />
                        }
                        tooltipMessage={tooltip.dashboard.numberOfBets}
                    />
                    <AdjacentContentBox
                        title="Number of Deposits (Last 24h)"
                        content={
                            <StatsNumber
                                fromNowOn={this.props.sandbox}
                                current={
                                    this.props.data
                                        .numberOfDepositsForTheLastDay.number
                                }
                                lastWeek={
                                    this.props.data
                                        .numberOfDepositsForTheLastDay
                                        .numberLastWeek
                                }
                            />
                        }
                        tooltipMessage={tooltip.dashboard.numberOfDeposits}
                    />
                    <AdjacentContentBox
                        title="Number of Withdrawals (Last 24h)"
                        content={
                            <StatsNumber
                                fromNowOn={this.props.sandbox}
                                current={
                                    this.props.data
                                        .numberOfWithdrawalsForTheLastDay.number
                                }
                                lastWeek={
                                    this.props.data
                                        .numberOfWithdrawalsForTheLastDay
                                        .numberLastWeek
                                }
                            />
                        }
                        tooltipMessage={tooltip.dashboard.numberOfWithdrawals}
                    />
                    <AdjacentContentBox
                        title="Players with Open Alerts"
                        content={
                            <StatsNumber
                                fromNowOn={this.props.sandbox}
                                current={
                                    this.props.data
                                        .numberOfPlayersWithOpenAlerts.number
                                }
                                lastWeek={
                                    this.props.data
                                        .numberOfPlayersWithOpenAlerts
                                        .numberLastWeek
                                }
                            />
                        }
                        tooltipMessage={tooltip.dashboard.playersOpenAlerts}
                    />
                </div>
            </Fragment>
        );
    }
}

export default StatsNumbers;
